<template>
    <modal :is-active.sync="modalDuplicarLeadComputed" title="Duplicar Lead">
        <form @submit.prevent="salvarDuplicarLead()">
            <div>
                <label for="duplicar_lead_produto">Produto</label>
                <select
                    class="browser-default"
                    v-model="formDataDuplicarLead.produto_id"
                    id="duplicar_lead_produto"
                >
                    <option value="" selected disabled>Selecione ...</option>
                    <option
                        :key="item.produto_id"
                        :value="item.produto_id"
                        v-for="item in produtosItens"
                    >
                        {{ item.produto_nome }}
                    </option>
                </select>
            </div>

            <div class="mt-3">
                <label for="duplicar_lead_estagio">Estágio</label>
                <select
                    class="browser-default"
                    v-model="formDataDuplicarLead.pedido_estagio_id"
                    id="duplicar_lead_estagio"
                >
                    <option value="" selected disabled>Selecione ...</option>
                    <option
                        :key="pedidoEstagio.pedido_estagio_id"
                        :value="pedidoEstagio.pedido_estagio_id"
                        v-for="pedidoEstagio in pedidoEstagios"
                    >
                        {{ pedidoEstagio.pedido_estagio_nome }}
                    </option>
                </select>
            </div>

            <div class="mt-3">
                <label for="duplicar_lead_plataforma_origem">
                    Plataforma de origem
                </label>
                <select
                    class="browser-default"
                    id="duplicar_lead_plataforma_origem"
                    v-model="formDataDuplicarLead.plataforma_origem"
                >
                    <option value="" selected disabled>Selecione ...</option>
                    <option value="1">Segasp Univalores</option>
                    <option value="2">Própria</option>
                </select>
            </div>

            <div class="mt-3 right-align">
                <button class="btn btn-default" type="submit">
                    Salvar
                </button>
            </div>
        </form>
    </modal>
</template>

<script>
import swal from "sweetalert2";

import { api, get } from "@/helpers/api";
import Message from "@/helpers/message";

import Modal from "@/components/common/Modal/Base.vue";

export default {
    components: {
        Modal
    },
    props: ["modalDuplicarLead", "formDataDuplicarLead"],
    data: () => ({
        produtosItens: [],
        pedidoEstagios: []
    }),
    methods: {
        salvarDuplicarLead() {
            if (!this.formDataDuplicarLead.produto_id) {
                Message.messageError("Selecione um produto.");
                return;
            }

            const postData = {
                empresa_indicada_id: this.formDataDuplicarLead
                    .empresa_indicada_id,
                cliente_id: this.formDataDuplicarLead.cliente_id,
                produto_id: this.formDataDuplicarLead.produto_id,
                pedido_estagio_id: this.formDataDuplicarLead.pedido_estagio_id,
                plataforma_origem: this.formDataDuplicarLead.plataforma_origem
            };

            api.post("cliente/duplicar-lead", postData)
                .then(() => {
                    this.$emit("close");

                    swal("Cliente duplicado com sucesso!", "", "success").then(
                        () => {
                            location.reload();
                        }
                    );
                })
                .catch(() => {
                    this.$emit("close");
                    swal("Erro ao duplicar o lead.", "", "error");
                });
        },
        getProdutos() {
            api.get("produto").then(res => {
                this.produtosItens = res.data.result.data;
            });
        },
        getPedidoEstagios() {
            get("pedido-estagio").then(res => {
                this.pedidoEstagios = res.data.result.data;
            });
        }
    },
    computed: {
        modalDuplicarLeadComputed: {
            get() {
                return this.modalDuplicarLead;
            },
            set(value) {
                if (!value) this.$emit("close");
            }
        }
    },
    created() {
        this.getProdutos();
        this.getPedidoEstagios();
    }
};
</script>



// WEBPACK FOOTER //
// src/components/lead/ModalDuplicarLead.vue